import styled from 'styled-components';
import defaultTheme from '../theme';

const HeaderTitle = styled.h2`
  margin: 0 !important;
  padding: 0 !important;
  font-size:${({ theme }) => theme.headerFontSize} !important;
  color: ${({ theme }) => theme.headerFontColor} !important;
`;

HeaderTitle.defaultProps = {
  theme: defaultTheme,
};

export default HeaderTitle;
